import {
  DownOutlined,
  LoadingOutlined,
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
  WalletOutlined,
} from '@ant-design/icons';
import { Avatar, Button, Dropdown, Space, Spin } from 'antd';
import { LINKS, SUPPORTED_LNGS } from 'configuration';
import dayjs from 'dayjs';
import { memo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { i18n, useTranslation } from 'translations';
import Cookies from 'util/cookies';
import { DROPDOWN_TRIGGER, METHODS } from 'util/params';
import { useRequest, useUser } from '@wappsto/blanket';
import { getSession, removeSession, useAppSelector } from '@wappsto/redux';

const PENDING = 'pending';

const UserMenu = memo(() => {
  const { tC } = useTranslation('features', 'userMenu');
  const dispatch = useDispatch();
  const { name, icon, status, user } = useUser();
  const session = useAppSelector(getSession);
  const { send } = useRequest();

  const logout = () => {
    send({
      method: METHODS.delete,
      url: `/session/${(session as any)?.meta?.id}`,
      abortable: false,
    });
    dispatch(removeSession());
    Cookies.remove('sessionID');
  };

  const items = [
    {
      label: <Link to={LINKS.account}>{tC('accountMenuButton')}</Link>,
      icon: <UserOutlined />,
      key: 'account',
    },
    {
      label: <Link to={LINKS.wallet}>{tC('walletMenuButton')}</Link>,
      icon: <WalletOutlined />,
      key: 'wallet',
    },
    {
      label: <Link to={LINKS.settings}>{tC('settingsMenuButton')}</Link>,
      icon: <SettingOutlined />,
      key: 'settings',
    },
    {
      label: tC('logoutButton'),
      icon: <LogoutOutlined />,
      onClick: logout,
      key: 'logout',
    },
  ];

  useEffect(() => {
    if (user?.language && SUPPORTED_LNGS.includes(user.language)) {
      i18n.changeLanguage(user.language);
      dayjs.locale(user.language);
    }
  }, [user?.language]);

  return (
    <Dropdown
      trigger={DROPDOWN_TRIGGER}
      menu={{ theme: 'dark', mode: 'vertical', items }}
      classNames={{root: 'user-menu-dropdown'}}>
      <Button className="user-menu-dropdown">
        <Space>
          {status === PENDING ? (
            <Spin size="small" indicator={<LoadingOutlined />} />
          ) : (
            <>
              <Avatar src={icon} size="small" icon={<UserOutlined />} />
              <span>{name}</span>
            </>
          )}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>
  );
});

UserMenu.displayName = 'UserMenu';

export default UserMenu;
